import { LoadingButton } from "@mui/lab";
import { useContext, useEffect, useState } from "react";
import useLocales from "src/hooks/useLocales";

import ThemeContext from "../../context";

// ----------------------------------------------------------------------

type Props = {
	loading?: boolean;
	userConfirmationNeeded?: boolean;
};

export const ConnectBtn = ({ loading, userConfirmationNeeded }: Props) => {
	const [isDisabled, setIsDisabled] = useState(false);

	const { entity } = useContext(ThemeContext);

	const { translate } = useLocales();

	if (entity?.maintenance) return null;

	useEffect(() => {
		if (userConfirmationNeeded) {
			setIsDisabled(true);
			setTimeout(() => {
				setIsDisabled(false);
			}, 5000);
		}
	}, [userConfirmationNeeded]);

	return (
		<LoadingButton
			variant='contained'
			size='large'
			type='submit'
			sx={{ mt: 5, width: "100%", alignSelf: "center" }}
			loading={loading}
			disabled={isDisabled}
		>
			{translate(`connect_panel.${userConfirmationNeeded ? "continue" : "connect"}`)}
		</LoadingButton>
	);
};

export default ConnectBtn;
